import { render, staticRenderFns } from "./newPublisher.vue?vue&type=template&id=df4c0aea&"
import script from "./newPublisher.vue?vue&type=script&lang=js&"
export * from "./newPublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports